<template>
    <erros-box :erros="erros"></erros-box>
    <p style="color: #666666; font-size: 1rem">{{ borderos.length }} pagamentos aguardando aprovação</p>

    <div class="p-fluid formgrid grid">
        <!-- <div class="field col-12" v-if="$temAcessoView('BORDEROS-05')">
            <div class="flex flex-row align-items-center">
                <Checkbox :modelValue="marcarTodos" binary id="selecionarTodosInput" variant="filled" @update:modelValue="marcarTodos = $event" />

                <label for="selecionarTodosInput" class="ml-2">Selecionar todos da página</label>
            </div>
        </div> -->
        <div v-for="bordero in dadosPaginados" v-bind:key="bordero?.borderoId" class="field col-12 md:col-6 xl:col-4">
            <BorderoCard
                :bordero="bordero"
                :deveMarcar="marcarTodos"
                :mostrarBotoes="borderosSelecionados.length <= 0"
                @aprovacaoReprovacao="$emit('atualizarDados')"
                @atualizouMarcacao="atualizarSelecionados($event)"
            ></BorderoCard>
        </div>
    </div>

    <h6 v-if="dadosPaginados.length <= 0">Nenhum borderô para aprovar...</h6>

    <Paginator
        v-if="dadosPaginados.length > 0"
        :rows="elementosPorPagina"
        :totalRecords="0 || borderos?.length"
        :rowsPerPageOptions="[5, 10, 20, 50]"
        @update:first="atualizaPrimeiroElemento($event)"
        @update:rows="atualizaElementosPorPagina($event)"
        @page="atualizaPaginaAtual($event)"
    />

    <div class="fixed bottom-0 left-0 p-2 botao-flutuante bg-white" v-if="borderosSelecionados.length > 0 && $temAcessoView('BORDEROS-05')">
        <div class="flex flex-row align-items-center justify-content-center">
            <Button
                class="lato-bolder bg-btn-reprovar margin-personalizada-btns btn-comum w-full flex flex-row align-items-center justify-content-center"
                @click="confirmarAprovarReprovar('reprovar')"
                style="font-family: 'Lato', Arial, sans-serif; font-weight: 700; font-size: 16px; color: #e0e3e7"
            >
                Reprovar
                <i class="pi pi-times mt-1 ml-2"> </i>
            </Button>

            <Button
                class="lato-bolder bg-btn-aprovar btn-comum w-full flex flex-row align-items-center justify-content-center gap-1"
                @click="confirmarAprovarReprovar('aprovar')"
                style="font-family: 'Lato', Arial, sans-serif; font-weight: 700; font-size: 16px; color: #fff"
            >
                Aprovar
                <i class="pi pi-check mt-1 ml-2"> </i>
            </Button>
        </div>
    </div>
</template>

<script>
import BorderoCard from './BorderoCard.vue';
import BorderosService from './service';

export default {
    components: {
        BorderoCard,
    },

    props: {
        borderos: {
            type: Array,
            default: () => [],
        },
    },

    emits: ['atualizarDados'],

    data() {
        return {
            elementosPorPagina: 5,
            paginaAtual: 0,
            primeiroElemento: 0,
            dadosPaginados: [],
            marcarTodos: false,
            borderosSelecionados: [],
            erros: [],
        };
    },

    mounted() {
        this.paginaElementos();
    },

    methods: {
        confirmarAprovarReprovar(acao = 'aprovar') {
            this.$confirm.require({
                message: `Tem certeza que deseja ${acao.toLowerCase()} o(s) borderô(s) selecionado(s)?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (acao == 'aprovar') {
                        this.aprovarSelecionados();
                    } else {
                        this.reprovarSelecionados();
                    }
                },
            });
        },

        atualizarSelecionados(opcaoParaAdionarRemover) {
            if (opcaoParaAdionarRemover?.deveRemover) {
                this.borderosSelecionados = this.borderosSelecionados.filter((borderoId) => opcaoParaAdionarRemover?.borderoId !== borderoId);
                return;
            }

            if (this.borderosSelecionados.filter((borderoId) => opcaoParaAdionarRemover?.borderoId == borderoId).length >= 1) return;

            this.borderosSelecionados = [...this.borderosSelecionados, opcaoParaAdionarRemover?.borderoId];
        },

        atualizaPrimeiroElemento(novoValor) {
            this.primeiroElemento = novoValor;
        },

        atualizaElementosPorPagina(elementosPorPagina) {
            this.elementosPorPagina = elementosPorPagina;
        },

        atualizaPaginaAtual(novaPagina) {
            this.paginaAtual = novaPagina;
            window.scrollTo(0, -100000);
        },

        paginaElementos(novoPrimeiroElemento = this.primeiroElemento, novoValorElementosPorPagina = this.elementosPorPagina) {
            const valorUltimoElementoListagem = novoPrimeiroElemento + novoValorElementosPorPagina - 1;

            if (valorUltimoElementoListagem >= this.borderos.length) {
                this.dadosPaginados = this.borderos.slice(novoPrimeiroElemento);
            }

            this.dadosPaginados = this.borderos.slice(novoPrimeiroElemento, valorUltimoElementoListagem + 1);
        },

        aprovarSelecionados() {
            this.$store.dispatch('addRequest');
            const aprovarBordero = { borderos: this.borderosSelecionados };
            BorderosService.aprovarBordero(aprovarBordero).then((response) => {
                if (response?.success) {
                    this.$emit('atualizarDados');
                    this.$toast.add({ severity: 'success', summary: 'Sucesso!', detail: 'Borderô aprovado com sucesso', life: 3000 });
                    this.borderosSelecionados = [];
                    this.marcarTodos = false;
                } else {
                    this.$toast.add({ severity: 'error', summary: 'Error!', detail: 'Error ao aprovado borderô', life: 3000 });
                    this.erros = response.errors;
                }
                this.$store.dispatch('removeRequest');
            });
        },

        reprovarSelecionados() {
            this.$store.dispatch('addRequest');
            const borderoReprovadoDto = { borderos: this.borderosSelecionados };
            BorderosService.reprovarBordero(borderoReprovadoDto).then((response) => {
                if (response?.success) {
                    this.$emit('atualizarDados');
                    this.$toast.add({ severity: 'success', summary: 'Sucesso!', detail: 'Borderô reprovado com sucesso', life: 3000 });
                    this.borderosSelecionados = [];
                    this.marcarTodos = false;
                } else {
                    this.$toast.add({ severity: 'error', summary: 'Erro!', detail: 'Erro ao reprovar borderô', life: 3000 });
                    this.erros = response.errors;
                }
                this.$store.dispatch('removeRequest');
            });
        },
    },

    watch: {
        borderos() {
            this.paginaElementos();
        },

        primeiroElemento(novoPrimeiroElemento) {
            this.paginaElementos(novoPrimeiroElemento);
        },

        elementosPorPagina(novoValorElementosPorPagina) {
            this.paginaElementos(null, novoValorElementosPorPagina);
        },
    },
};
</script>

<style scoped>
@media (min-width: 1024px) {
    .col-19w {
        width: 19%;
    }
}

.tamanho-com-menu {
    width: calc(100% - 288px);
    left: 288px;
}

.m-left {
    margin-left: 288px;
}

.bg-btn-aprovar {
    border-color: #3e6ba8;
    background-color: #3e6ba8;
}

.bg-btn-aprovar:hover {
    border-color: #3e6ba8;
    background-color: #3e6ba8;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.bg-btn-reprovar {
    border-color: #e54d2e;
    background-color: #e54d2e;
}

.bg-btn-reprovar:hover {
    border-color: #e54d2e;
    background-color: #e54d2e;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.btn-comum {
    height: 2.5rem;
}

.margin-personalizada-btns {
    margin-right: 1.125rem;
}

.botao-flutuante {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
}

@media (min-width: 897px) {
    .botao-flutuante {
        position: fixed;
        bottom: 0;
        left: 288px !important;
        width: calc(100% - 288px);
    }
}
</style>
